import React from 'react'
import { IoHomeSharp } from "react-icons/io5";
import { MdPodcasts } from "react-icons/md";
import { BiSolidRadio } from "react-icons/bi";
import { IoCalendarNumber } from "react-icons/io5";
import { BiSolidMegaphone } from "react-icons/bi";
import { GrGallery } from "react-icons/gr";
import { RiTeamFill } from "react-icons/ri";
import { BsCalendar2CheckFill } from "react-icons/bs";
import { NavLink } from 'react-router-dom';

function Bottombar() {
    return (
        <div className='bottombar-main'>
            <div className='bottombar-main-inner-div'>
                <NavLink to="/" className={(navData) => navData.isActive ? "bottomber-single-option-active" : "bottomber-single-option-not-active"} style={{ margin: "0px" }}>
                    <div className='bottomber-single-option'>
                        <IoHomeSharp />
                        <p>Home</p>
                    </div></NavLink>
                <NavLink to="/podcast" className={(navData) => navData.isActive ? "bottomber-single-option-active" : "bottomber-single-option-not-active"}>
                    <div className='bottomber-single-option'>
                        {/* <BiSolidRadio /> */}
                        <MdPodcasts />
                        <p>Podcast</p>
                    </div></NavLink>
                <NavLink id="interviews-for-laptop0988" to="/interviews" className={(navData) => navData.isActive ? "bottomber-single-option-active" : "bottomber-single-option-not-active"}>
                    <div className='bottomber-single-option'>
                        <RiTeamFill />
                        <p>Interviews</p>
                    </div></NavLink>
                <NavLink to="/schedule" className={(navData) => navData.isActive ? "bottomber-single-option-active" : "bottomber-single-option-not-active"}>
                    <div className='bottomber-single-option'>
                        <IoCalendarNumber />
                        <p>Schedule</p>
                    </div></NavLink>
                <NavLink id="gallery-for-laptop0988" to="/albums" className={(navData) => navData.isActive ? "bottomber-single-option-active" : "bottomber-single-option-not-active"}>
                    <div className='bottomber-single-option'>
                        <GrGallery />
                        <p>Gallery</p>
                    </div></NavLink>
                <NavLink to="/news" className={(navData) => navData.isActive ? "bottomber-single-option-active" : "bottomber-single-option-not-active"}>
                    <div className='bottomber-single-option'>
                        <BiSolidMegaphone />
                        <p>News</p>
                    </div></NavLink>
                <NavLink id="event-for-phone0988" to="/events" className={(navData) => navData.isActive ? "bottomber-single-option-active" : "bottomber-single-option-not-active"}>
                    <div className='bottomber-single-option'>
                        <BsCalendar2CheckFill />
                        <p>Events</p>
                    </div></NavLink>
            </div>
        </div>
    )
}

export default Bottombar